import { render, staticRenderFns } from "./RegisterCovidLanding.vue?vue&type=template&id=afe9dbd8&scoped=true"
import script from "./RegisterCovidLanding.vue?vue&type=script&lang=js"
export * from "./RegisterCovidLanding.vue?vue&type=script&lang=js"
import style0 from "./RegisterCovidLanding.vue?vue&type=style&index=0&id=afe9dbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe9dbd8",
  null
  
)

export default component.exports